import { render } from "./S195239.vue?vue&type=template&id=64b971b6"
const script = {}
script.render = render

export default script